import React, { useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useReactToPrint } from 'react-to-print';

import logo from '../assets/logo_patos.png';
import brasao from '../assets/brasao.png';

import moment from 'moment';


export const DialogPrintBoletimPorGrupo = ({ visible, setVisible, boletins, setBoletins }) => {
    const cssText = `
    #print-content {
        font-family: 'Open Sans', sans-serif;
        width: 100%;
        text-align: center;
    }

    .contRomaneio {
        page-break-after: always;
    }
        .foot {
            page-break-after: always;
        }

        img {
            width: 50px;
            height: auto;
            display: block;
            border: block red;
        }

        .header-img {
            display: flex;
            justify-content: center;
        }

        .header {
            display: flex;
            align-items: center;
            flex-direction: column;
        }

        h3 {
            margin-bottom: 0px;
            min-width: 100%;
            margin: 0 100px 0 100px;
            text-align: left;

        }

        h4 {
            margin-bottom: 0px;
            min-width: 100%;
            margin: 0 100px 0 100px;
            text-align: center;
            font-size: 11px;
        }

        h2 {
            margin-bottom: 0px;
            min-width: 100%;
            margin: 0 100px 0 100px;

        }

        h2 span {
            font-size: 14px;
        }

        th span {
            font-size: 14px;
            font-weight: normal;
        }

        thead {
            font-size: 14px;
            font-weight: normal;
        }

        tbody {
            font-size: 14px;
            font-weight: normal;
        }

        span {
            font-size: 12px;
        }

        #rodape {
            border-top: 1px solid #333;
            bottom: 0;
            left: 0;
            height: 40px;
            position: fixed;
            width: 100%;
        }

        #rodape2 {
            margin-top: 30px;
            border-top: 1px solid #333;
            bottom: 0;
            left: 0;
            height: 40px;
            width: 100%;
        }

        .content-row {
            page-break-inside: avoid;
          }

        .break-row {
            page-break-before: always;
        }


    `

    
    const listaItens = () => boletins.map((boletim, index) => {
        
        return (
            <tr key={index}>
                <td width="230px" align="center"><span>{boletim.boletimId}</span></td>
                <td width="230px" align="center"><span>{boletim.propriedade}</span></td>
                <td width="230px" align="center"><span>{boletim.produtor}</span></td>
                <td width="230px" align="center"><span>{boletim.celular}</span></td>
                <td width="230px" align="center"><span>{boletim.produtoNome}</span></td>
                <td width="230px" align="center"><span>{boletim.produtoEmbalagem}</span></td>
                <td width="230px" align="center"><span>{moment(boletim.dataEmissao).format('DD/MM/YYYY')}</span></td>
                <td width="230px" align="center"><span>{moment(boletim.fimColheita).format('DD/MM/YYYY')}</span></td>
            </tr>
        );
    });


    const contentRef = useRef(null);
    const reactToPrintFn = useReactToPrint({ contentRef, pageStyle: cssText });

    const header = (
        <div>
            <Button label="Imprimir" className="p-button-secondary" icon="pi pi-print" onClick={reactToPrintFn} />
        </div>
    );
    

    return (
        <Dialog
            visible={visible}
            onHide={() => setVisible(false)}
            header={header}
            className='p-scrollpanel-bar-y'
            breakpoints={{ '960px': '75vw', '640px': '100vw' }}
            style={{ width: '50vw', heigth: '5vw' }}
        >

            <div id="print-content" ref={contentRef}>

                <div className='contRomaneio'>
                    <table>
                        <tr>
                            <th>
                                <div className="p-d-flex p-jc-right header-img">
                                    <img style={{ width: 60, height: 'auto' }}
                                        id="img"
                                        className='img'
                                        alt="brasao"
                                        src={brasao}
                                    />
                                </div>
                            </th>
                            <th>
                                <div className="p-d-flex p-jc-center header-img " >
                                    <h4> <span> MUNICÍPIO DE PATOS DE MINAS / SEC. MUNICIPAL DE AGRIC. PEC. E ABASTECIMENTO </span>  <br />
                                        CEASA REGIONAL  <br />
                                        RELATÓRIO DE BOLETINS POR GRUPO DE PRODUTO </h4>
                                </div>
                            </th>
                            <th>
                                <div className="p-d-flex p-jc-left header-img">
                                    <img style={{ width: 60, height: 'auto' }}
                                        id="img"
                                        alt="Logo"
                                        className='img'
                                        src={logo}
                                    />
                                </div>
                            </th>

                        </tr>

                    </table>

                    <hr />


                    <table width="100%" border="1" style={{ 'border-collapse': 'collapse', 'pageBreakInside': 'avoid' }} cellpadding="5px" cellspacing="0">

                        <thead>
                            <tr>
                                <th width="100px" ><span><i>Boletim Id</i></span></th>
                                <th width="100px" ><span><i>Propriedade</i></span></th>
                                <th width="100px" ><span><i>Produtor</i></span></th>
                                <th width="100px" ><span><i>Celular</i></span></th>
                                <th width="100px" ><span><i>Produto</i></span></th>
                                <th width="100px" ><span><i>Embalagem</i></span></th>
                                <th width="100px" ><span><i>Data Emissão</i></span></th>
                                <th width="100px" ><span><i>Fim Colheita</i></span></th>

                            </tr>
                        </thead>

                        <tbody>

                            {listaItens()}

                        </tbody>

                        <footer id="rodape">
                            <table width="100%" border="0" style={{ 'border-collapse': 'collapse' }} cellpadding="5px" cellspacing="0">
                                <thead>

                                </thead>

                            </table>
                        </footer>

                    </table>

                </div>


            </div>

        </Dialog>
    );
}
